module.exports = __webpack_public_path__ + "img/kf_img.dac8af25.png";